'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_NameUtils$() {
}
export { $c_Ldev_cheleb_scalamigen_NameUtils$ as $c_Ldev_cheleb_scalamigen_NameUtils$ };
$p = $c_Ldev_cheleb_scalamigen_NameUtils$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_NameUtils$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_NameUtils$() {
}
export { $h_Ldev_cheleb_scalamigen_NameUtils$ as $h_Ldev_cheleb_scalamigen_NameUtils$ };
$h_Ldev_cheleb_scalamigen_NameUtils$.prototype = $p;
$p.Y0 = (function(string) {
  var $x_21 = $j_java$002elang$002e$002dObject.$m_s_Predef$();
  $j_java$002elang$002e$002dObject.$m_sc_StringOps$();
  var len = string.length;
  var sb = $j_java$002elang$002e$002dObject.$ct_jl_StringBuilder__I__(new $j_java$002elang$002e$002dObject.$c_jl_StringBuilder(), len);
  var i = 0;
  while ((i < len)) {
    var index = i;
    var x = string.charCodeAt(index);
    if ($j_java$002elang$002e$002dObject.$m_jl_UnicodeData$().xs(x)) {
      var str = ("" + $j_java$002elang$002e$002dObject.$cToS(x));
      sb.r = (sb.r + str);
    }
    i = ((1 + i) | 0);
  }
  var xs = $j_java$002elang$002e$002dObject.$f_T__split__T__I__AT(((len === sb.l()) ? string : sb.r), "(?=[A-Z])", 0);
  var f = ((_$2$2) => $j_java$002elang$002e$002dObject.$m_sc_StringOps$().SE(_$2$2));
  var ct__runtimeClass;
  var ct__runtimeClass = $j_java$002elang$002e$002dObject.$d_T.l();
  var len$1 = xs.a.length;
  var componentType = ct__runtimeClass;
  var ys = componentType.J.U(len$1);
  if ((len$1 > 0)) {
    var i$1 = 0;
    if ((xs !== null)) {
      while ((i$1 < len$1)) {
        var $x_2 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_1 = i$1;
        var x0 = xs.a[i$1];
        $x_2.F(ys, $x_1, f(x0));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
      while ((i$1 < len$1)) {
        var $x_4 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_3 = i$1;
        var x0$1 = xs.a[i$1];
        $x_4.F(ys, $x_3, f(x0$1));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
      while ((i$1 < len$1)) {
        var $x_6 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_5 = i$1;
        var x0$2 = xs.a[i$1];
        $x_6.F(ys, $x_5, f(x0$2));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
      while ((i$1 < len$1)) {
        var $x_10 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_9 = i$1;
        var $x_7 = xs.a;
        var $x_8 = (i$1 << 1);
        var x0$3_$_lo = $x_7[$x_8];
        var x0$3_$_hi = $x_7[(($x_8 + 1) | 0)];
        $x_10.F(ys, $x_9, f($j_java$002elang$002e$002dObject.$bL(x0$3_$_lo, x0$3_$_hi)));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
      while ((i$1 < len$1)) {
        var $x_12 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_11 = i$1;
        var x0$4 = xs.a[i$1];
        $x_12.F(ys, $x_11, f(x0$4));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
      while ((i$1 < len$1)) {
        var $x_14 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_13 = i$1;
        var x0$5 = xs.a[i$1];
        $x_14.F(ys, $x_13, f($j_java$002elang$002e$002dObject.$bC(x0$5)));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
      while ((i$1 < len$1)) {
        var $x_16 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_15 = i$1;
        var x0$6 = xs.a[i$1];
        $x_16.F(ys, $x_15, f(x0$6));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
      while ((i$1 < len$1)) {
        var $x_18 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_17 = i$1;
        var x0$7 = xs.a[i$1];
        $x_18.F(ys, $x_17, f(x0$7));
        i$1 = ((1 + i$1) | 0);
      }
    } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
      while ((i$1 < len$1)) {
        var $x_20 = $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$();
        var $x_19 = i$1;
        var x0$8 = xs.a[i$1];
        $x_20.F(ys, $x_19, f(x0$8));
        i$1 = ((1 + i$1) | 0);
      }
    } else {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
    }
  }
  return $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_21.iy(ys), "", " ", "");
});
var $d_Ldev_cheleb_scalamigen_NameUtils$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_NameUtils$, "dev.cheleb.scalamigen.NameUtils$", ({
  jf: 1
}));
export { $d_Ldev_cheleb_scalamigen_NameUtils$ as $d_Ldev_cheleb_scalamigen_NameUtils$ };
var $n_Ldev_cheleb_scalamigen_NameUtils$;
function $m_Ldev_cheleb_scalamigen_NameUtils$() {
  if ((!$n_Ldev_cheleb_scalamigen_NameUtils$)) {
    $n_Ldev_cheleb_scalamigen_NameUtils$ = new $c_Ldev_cheleb_scalamigen_NameUtils$();
  }
  return $n_Ldev_cheleb_scalamigen_NameUtils$;
}
export { $m_Ldev_cheleb_scalamigen_NameUtils$ as $m_Ldev_cheleb_scalamigen_NameUtils$ };
